import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import { Paper, Typography } from "@mui/material";
import { SearchBar } from "src/chamber/features/dashboard/ui/SearchBar";
import { useState } from "react";
import GavelIcon from "@mui/icons-material/Gavel";
import ViolationCasesRedirector from "src/chamber/features/dashboard/ui/ViolationCasesRedirector";

type TViolationCasesProps = {
  activeViolationCasesApplications: number | null;
  assignChamberAdminDashboard: number | null;
  isOrgAdmin: boolean;
  isSampleInitiator: boolean;
  violationTypes: { value: number; label: string }[];
  chamberUsers: { label: string; value: number; isChamberAdmin: boolean }[];
  violationStatuses: {
    descr: string;
    id: number;
  }[];
  activeOwnViolationCasesCount: number | null;
  unassignedViolationCasesCount: number | null;
  countsLoading?: boolean;
};

function ViolationCases(props: TViolationCasesProps) {
  const { t } = useTranslation();
  const [protocol, setProtocol] = useState("");
  const [gemi, setGemi] = useState("");

  return (
    <Paper sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem",
        }}
      >
        <Typography
          variant="h5"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <GavelIcon />
          {t("Παραβάσεις - Πρόστιμα")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <SearchBar
          mode={"violationCase"}
          protocol={protocol}
          gemi={gemi}
          setProtocol={setProtocol}
          setGemi={setGemi}
        />
      </Box>

      <ViolationCasesRedirector
        countsLoading={props.countsLoading}
        chamberUsers={props.chamberUsers}
        violationTypes={props.violationTypes}
        isOrgAdmin={props.isOrgAdmin}
        isSampleInitiator={props.isSampleInitiator}
        violationStatuses={props.violationStatuses}
        activeOwnViolationCasesCount={props.activeOwnViolationCasesCount}
        unassignedViolationCasesCount={props.unassignedViolationCasesCount}
      />
    </Paper>
  );
}

export default ViolationCases;
